(function ($) {
  Drupal.behaviors.skipToCheckoutV1 = {
    attach: function (context) {
      var urlParams = new URLSearchParams(window.location.search);
      var isCheckout = urlParams.get('is_checkout');
      var $container = $('.js-skip-to-checkout-v1', context);

      if (isCheckout === '1') {
        $container.removeClass('hidden');
      }
    }
  };
})(jQuery);
